import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Cargando...</div>;
}

const NotAllowedComponent = Loadable({
    loader: () => import('../../Components/Common/Error/NotAllowedComponent'),
    loading: Loading,
});

const NotFoundComponent = Loadable({
    loader: () => import('../../Components/Common/Error/NotFoundComponent'),
    loading: Loading,
});

const errorRoutes = [
    { path: '/error/not-allowed', exact: true, name: 'Acceso no permitido', component: NotAllowedComponent },
    { path: '/error/not-found', exact: true, name: 'Pagina no encontrada', component: NotFoundComponent },
];

export default errorRoutes;


// WEBPACK FOOTER //
// ./src/Routes/Modules/error.js